import {commentator} from '@utilities/sal-commentator/sal-commentator';

const CONSTANTS = {
    ACCORDION_CLASS: '.accordion',
    ACCORDION_HEADER: '.accordion__header',
    ACCORDION_BODY: '.accordion__body',
    ACCORDION_BODY_HIDE: 'accordion--hide',
    ACCORDION_BODY_SHOW: 'accordion--show',
    ACCORDION_ICON_EXPANDED: 'minus',
    ACCORDION_ICON_COLLAPSED: 'plus'
};

let hashChangeHandlerRegistered = false;

/*
<span class="icon-toggle plus">
    <span class="horizontal"></span>
    <span class="vertical"></span>
</span>
 */

const findNextBody = function(elem) {
    if  (!elem) {
        return null;
    }
    let nextBody = elem.closest(CONSTANTS.ACCORDION_CLASS);
    if (!nextBody) {
        return null;
    }
    return nextBody.querySelector(CONSTANTS.ACCORDION_BODY);
};

const eventHandler = {
    toggle: (e) => {
        eventHandler._processEvent(e, 'toggle');
    },
    open: (e) => {
        eventHandler._processEvent(e, 'open');
    },
    close: (e) => {
        eventHandler._processEvent(e, 'close');
    },

    _processEvent: (e, targetState) => {
        if (typeof e.stopPropagation === 'function') e.stopPropagation();
        const accordionHeader = e.currentTarget;
        const accordionBody = findNextBody(accordionHeader);

        const icon = accordionHeader.querySelector(".icon-toggle");

        // change icon
        if (targetState === 'open' || (targetState === 'toggle' && icon.classList.contains(CONSTANTS.ACCORDION_ICON_COLLAPSED))) {
            icon.classList.remove(CONSTANTS.ACCORDION_ICON_COLLAPSED);
            icon.classList.add(CONSTANTS.ACCORDION_ICON_EXPANDED);
        } else {
            icon.classList.remove(CONSTANTS.ACCORDION_ICON_EXPANDED);
            icon.classList.add(CONSTANTS.ACCORDION_ICON_COLLAPSED);
        }

        // show / hide body element
        if (targetState === 'close' || (targetState === 'toggle' && accordionBody.classList.contains(CONSTANTS.ACCORDION_BODY_SHOW))) {
            accordionBody.classList.remove(CONSTANTS.ACCORDION_BODY_SHOW);
            accordionBody.classList.add(CONSTANTS.ACCORDION_BODY_HIDE);
        } else {
            accordionBody.classList.remove(CONSTANTS.ACCORDION_BODY_HIDE);
            accordionBody.classList.add(CONSTANTS.ACCORDION_BODY_SHOW);
        }

        eventHandler.transitionTrigger({ currentTarget: accordionBody });
    },

    transitionTrigger: (e) => {

        const accordionBody = e.currentTarget;

        if(accordionBody.classList.contains(CONSTANTS.ACCORDION_BODY_HIDE)) {
            commentator.insertCommentBefore(accordionBody, 'accordion.js', commentator.getPresets().STYLE);
            accordionBody.style.display = "none";
        } else {
            commentator.insertCommentBefore(accordionBody, 'accordion.js', commentator.getPresets().STYLE);
            accordionBody.style.display = "block";
        }
    },

    hashChange: () => {
        const hash = window.location.hash;
        const accordionHeader = document.querySelector(hash);
        const accordionBody = findNextBody(accordionHeader);

        if (accordionHeader && accordionBody) {
            eventHandler.open({ currentTarget: accordionHeader });
        }
    }
};

const accordion = {
    init: () => {
        const accordionHeaderElements = document.querySelectorAll(`${CONSTANTS.ACCORDION_CLASS} ${CONSTANTS.ACCORDION_HEADER}`);

        if (accordionHeaderElements.length > 0) {

            const horizontal = document.createElement("span");
            horizontal.classList.add("horizontal");
            const vertical = document.createElement("span");
            vertical.classList.add("vertical");
            const iconToggle = document.createElement("span");
            iconToggle.classList.add("icon-toggle");

            iconToggle.appendChild(horizontal);
            iconToggle.appendChild(vertical);

            let hashSelectedElement = "";
            try {
                hashSelectedElement = document.querySelector(document.location.hash);
            } catch {
                // kein gültiger Selector
            }

            accordionHeaderElements.forEach((element, i) => {
                try {
                    const header = element.firstChild; // <header>; das ist genau so intuitiv, wie überall parentNode zu benutzen ;-)
                    let icon = iconToggle.cloneNode(true);

                    // Automatisch geöffnet wird:
                    // - das 1. Accordion, wenn es keine Klasse hat, die das verhindert
                    // - das Accordion dessen ID im UrlHash steht :-)
                    const autoOpenAccordion = (
                        (i === 0 && !element.classList.contains('accordion--noautoopen'))
                        ||
                        (hashSelectedElement && (hashSelectedElement === element || element.compareDocumentPosition(hashSelectedElement) & Node.DOCUMENT_POSITION_CONTAINS))
                    );

                    if (autoOpenAccordion) {
                        icon.classList.add("minus");
                        if (header.firstChild.tagName === "H3") {
                            header.prepend(icon);
                            element.classList.add("accordion__header--headline-3")
                        } else {
                            header.appendChild(icon);
                            element.classList.add("accordion__header--headline-2")
                        }
                        let accordionBodyElement = findNextBody(element);
                        accordionBodyElement.classList.add(CONSTANTS.ACCORDION_BODY_SHOW);
                        accordionBodyElement.addEventListener('transitionend', eventHandler.transitionTrigger)
                    } else {
                        icon.classList.add("plus");
                        if (header.firstChild.tagName === "H3") {
                            header.prepend(icon);
                            element.classList.add("accordion__header--headline-3")
                        } else {
                            header.appendChild(icon);
                            element.classList.add("accordion__header--headline-2")
                        }
                        let accordionBodyElement = findNextBody(element);
                        accordionBodyElement.classList.add(CONSTANTS.ACCORDION_BODY_HIDE);
                        accordionBodyElement.style.display = 'none';
                    }

                    element.addEventListener('click', eventHandler.toggle);
                    element.addEventListener('accordion-open', eventHandler.open);
                    element.addEventListener('accordion-close', eventHandler.close);
                }
                catch (e) {
                    console.warn('Failed to initialize accordion', element, e);
                }
            });

            if (!hashChangeHandlerRegistered) {
                window.addEventListener('hashchange', eventHandler.hashChange);
                hashChangeHandlerRegistered = true;
            }
        }
    }
};

export { accordion };
